module.exports = __webpack_public_path__ + "img/bg-us.4f69382e.webp";